import { useEffect } from 'react';
import TabsHeader from '../../components/TabsHeader/TabsHeader';
import { FireDanger } from 'components/SpecialReports/FireDanger';
import { SkiReports } from 'components/SpecialReports/SkiReports';
import { AirportDelay } from 'components/SpecialReports/AirportDelay';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { usePerms } from 'contexts/PermsContext';
import MobileTabsHeader from 'components/TabsHeader/MobileTabsHeader';
import { EarthquakeReports } from 'components/SpecialReports/EarthquakeReports';
import { Container } from 'react-bootstrap';

export default function SpecialReports() {
  const [params] = useSearchParams();
  const perms = usePerms();
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      if (!(await perms.validatePermissions(['SpecialReportsEnabled']))) {
        navigate('/404');
        return;
      }
    })();
  }, []);

  const renderTab = () => {
    switch (params.get('tab')?.toLowerCase()) {
      case 'fire danger':
        return <FireDanger />;
      case 'earthquake reports':
        return <EarthquakeReports />;
      case 'ski reports':
        return <SkiReports />;
      case 'airport delay':
        return <AirportDelay />;

      default:
        return <FireDanger />;
    }
  };

  return (
    <Container fluid className="d-flex flex-column h-100 py-3">
      {/* header */}
      <div className="d-none d-lg-block">
        <TabsHeader
          options={[
            { option: 'Fire Danger' },
            { option: 'Earthquake Reports' },
            { option: 'Ski Reports' },
            { option: 'Airport Delay' },
          ]}
          styles={[{ backgroundColor: '#436c98' }]}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileTabsHeader
          options={[
            { option: 'Fire Danger' },
            { option: 'Earthquake Reports' },
            { option: 'Ski Reports' },
            { option: 'Airport Delay' },
          ]}
        />
      </div>
      {/* content */}
      <div
        style={{
          height: 'calc(100% - 48px)',
        }}
      >
        {renderTab()}
      </div>
    </Container>
  );
}
